import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import Pager from '@/components/PagerComponent'
import { useToast } from 'vue-toast-notification';

export default {

  components: {
    Pager
  },

  setup () {
    return { v$: useVuelidate() }
  },

  data () {
    return {
      permissions: JSON.parse(sessionStorage.getItem('user')).permissions,
      criterias: {
        selectedDistributorRef: ''
      },
      displayedProducts: [],
      distributors: [],
      responseErr: '',
      error: false,
      validationError: false,
      isProcessing: false,
      isDistributorLocked: true
    }
  },

  created () {
    if(this.$store.state.products.invalidData) {
      const $toast = useToast();
      $toast.open({
        message: this.$i18n.t('error.' + this.$store.state.products.invalidData),
        type:'default',
        position: 'bottom',
        duration: 5000,
        dismissible:true
      });
    }
    this.$store.dispatch('products/resetInvalidData')
    const user = JSON.parse(sessionStorage.getItem('user'))
    if (user.ihmDistribRef) {
      this.criterias.selectedDistributorRef = user.ihmDistribRef
      this.isDistributorLocked = true
      this.getProducts()
    } else {
      this.isDistributorLocked = false
      this.getDistributors(user)
    }
  },

  methods: {
    hasPermission (permission) {
      if (!String.prototype.includes) {
        return this.permissions.indexOf(permission, 0) !== -1
      } else {
        return this.permissions.includes(permission)
      }
    },

    search () {
      this.validationError = this.v$.$invalid

      if (!this.validationError) {
        this.getProducts()
      }
    },

    async getDistributors (user) {
      this.distributors = Object.keys(user.comProductsMap).sort()
    },

    async getProducts () {
      this.isProcessing = true
      this.error = false

      await this.$store.dispatch('products/reset')
      await this.$store.dispatch('products/search', {
        idDistributeur: this.criterias.selectedDistributorRef
      }).then(
        () => {
          this.isProcessing = false
        },
        error => {
          this.isProcessing = false
          this.error = true
          this.responseErr = (error || 'BAD_REQUEST').toUpperCase()
        }
      )
    },

    getIssuerId (distrRef) {
      const user = JSON.parse(sessionStorage.getItem('user'))
      return Object.keys(user.comProductsMap[distrRef])[0]
    },

    status (validation) {
      return {
        'validation-error': validation.$invalid && this.validationError
      }
    },

    async showDetails (product) {
      this.$store.dispatch('products/setProduct', {
        prb1: product.prb1,
        prb7: product.prb7
      })
      this.$router.push({ name: 'product-detail' })
    },

    async showEdit (product) {
      this.$store.dispatch('products/setProduct', {
        prb1: product.prb1,
        prb7: product.prb7
      })
      this.$router.push({ name: 'product-edit' })
    },

    async showCreate (product) {
      this.$store.dispatch('products/setProduct', {
        prb1: product.prb1,
        prb7: product.prb7
      })
      this.$router.push({ name: 'product-copy' })
    },

    reset () {
      this.$store.dispatch('products/reset')
      this.validationError = false
      this.error = false
      this.criterias.selectedDistributorRef = ''
    }
  },

  validations () {
    return {
      criterias: {
        selectedDistributorRef: { required }
      }
    }
  }
}
